import { initialized } from '../App/action';
import { Middleware } from '../index';
import { PersistType } from './action';

export class PersistMiddleware {
    public middleware: Middleware = store => next => action => {
        next(action);

        if (action.type === PersistType.Rehydrate) {
            return store.dispatch(initialized());
        }
    };
}
